import { StepProps as MuiStepProps } from '@mui/material/Step'
import { StepLabelProps as MuiStepLabelProps } from '@mui/material/StepLabel'
import { StepperProps as MuiStepperProps } from '@mui/material/Stepper'

export type StepperProps = MuiStepperProps
export type StepProps = MuiStepProps
export type StepLabelProps = MuiStepLabelProps
